import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types'
import {differenceInDays, max, min} from 'ag-common/facades'
import AzubiListHOC from '#components/HOC/AzubiListHOC'
import convertHexToRGB from '#tools/convertHexToRGB'
import CalendarTooltip from './CalendarTooltip'

const Department = ({
  abteilung,
  from,
  to,
  startOfCalendar,
  endOfCalendar,
  istZeit,
  sollZeit,
  isLoadingAzubis,
  isDraft,
  setSelectedAbteilungsEinsatz,
  userId,
  id,
  isDashboardView = false,
}) => {
  const [wrapperClassList, setWrapperClassList] = useState(['department'])

  useEffect(() => {
    setWrapperClassList([...wrapperClassList, 'fadeIn'])
  }, [])

  const getBackgroundForColor = color => {
    const lighterColor = convertHexToRGB(color, 0.2)
    if (isDraft) {
      const lighterStripeColor = convertHexToRGB(color, 0.1)
      return `repeating-linear-gradient(135deg, ${lighterStripeColor} 0px, ${lighterStripeColor} 5px, ${lighterColor} 5px, ${lighterColor} 7px)`
    }
    return lighterColor
  }

  const isExpired = 0 < differenceInDays(new Date(), to)

  const gridColumnOffset = isDashboardView ? 0 : 1

  const gridColumn = `${
    differenceInDays(max([from, startOfCalendar]), startOfCalendar) + 1 + gridColumnOffset
  } / span ${differenceInDays(min([to, endOfCalendar]), max([from, startOfCalendar])) + 1}`

  const color = isExpired ? '#999999' : abteilung.backgroundColor
  const timeText = sollZeit > 0 ? `${istZeit}/${sollZeit}` : `${istZeit}`
  const background = getBackgroundForColor(color)

  if (isLoadingAzubis) {
    return null
  }

  return (
    <CalendarTooltip text={abteilung.name} from={from} to={to} position={CalendarTooltip.Position.BOTTOM}>
      {ref => (
        <div className="department-wrapper" ref={ref} style={{gridColumn}}>
          <div
            className="department"
            data-testid="department"
            data-to={to}
            data-from={from}
            onClick={() => setSelectedAbteilungsEinsatz({userId, id, from, to, abteilung})}
            style={{
              borderColor: color,
              background,
            }}>
            <div className="text-wrapper">
              <div className="departmentName">
                {abteilung.name}
                <span className="istSollZeit" style={{color}}>
                  {timeText}
                </span>
              </div>
            </div>
          </div>
        </div>
      )}
    </CalendarTooltip>
  )
}

Department.propTypes = {
  isLoadingAzubis: PropTypes.bool,
  isDraft: PropTypes.bool,
  abteilung: PropTypes.shape({
    name: PropTypes.string,
    backgroundColor: PropTypes.string,
  }).isRequired,
  from: PropTypes.instanceOf(Date).isRequired,
  to: PropTypes.instanceOf(Date).isRequired,
  startOfCalendar: PropTypes.instanceOf(Date).isRequired,
  endOfCalendar: PropTypes.instanceOf(Date).isRequired,
  sollZeit: PropTypes.number,
  istZeit: PropTypes.number,
  setSelectedAbteilungsEinsatz: PropTypes.func,
  userId: PropTypes.number.isRequired,
  id: PropTypes.string.isRequired,
  isDashboardView: PropTypes.bool,
}

export default AzubiListHOC(Department)
